import {IHttpService} from "angular";
import {AchievementStates} from "../models/AchievementState";

export class AchievementService {

    public static readonly id = "achievementService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async list(): Promise<AchievementStates> {
        const url = "/tradefloor/api/achievements";
        const response = await this.$http.get<AchievementStates>(url);
        return response.data!;
    }
}